var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShareNew(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_1483",
    "data-name": "Grupo 1483",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22.502,
    height: 22.499,
    viewBox: "0 0 22.502 22.499",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_791",
    "data-name": "Rect\\xE1ngulo 791",
    width: 22.502,
    height: 22.499,
    fill: "#3d3d3d"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1482",
    "data-name": "Grupo 1482",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7303",
    "data-name": "Trazado 7303",
    d: "M11.25,201.956c-2.092,0-4.183.015-6.275,0a4.815,4.815,0,0,1-4.342-2.506A4.605,4.605,0,0,1,0,197.091C0,195.662,0,194.233,0,192.8a1.032,1.032,0,0,1,.737-1.032.977.977,0,0,1,1.126.419,1.413,1.413,0,0,1,.175.654c.015,1.373.007,2.746.008,4.119A2.852,2.852,0,0,0,5,199.907H17.5a2.851,2.851,0,0,0,2.949-2.943c0-1.4,0-2.794,0-4.19a1.017,1.017,0,0,1,.694-.988.968.968,0,0,1,1.113.333,1.17,1.17,0,0,1,.227.612c.009,1.6.046,3.194-.031,4.787a4.818,4.818,0,0,1-3.977,4.348,6.8,6.8,0,0,1-1.048.085c-2.06.008-4.119,0-6.179,0",
    transform: "translate(0.001 -179.462)",
    fill: "#3d3d3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_7304",
    "data-name": "Trazado 7304",
    d: "M70.323,3.5c-.116.111-.18.169-.241.231Q68.049,5.765,66.017,7.8A1.044,1.044,0,0,1,65,8.142,1.017,1.017,0,0,1,64.43,6.5a2.344,2.344,0,0,1,.165-.174L70.507.419A1.042,1.042,0,0,1,72.172.413q2.973,2.972,5.947,5.943a1.034,1.034,0,0,1,.336,1.017,1.012,1.012,0,0,1-1.7.509c-.447-.422-.873-.866-1.307-1.3Q74.02,5.151,72.591,3.718a1.3,1.3,0,0,1-.143-.214l-.089.059v.276q0,6.2,0,12.407a1.02,1.02,0,1,1-2.03.2c-.008-.111-.006-.223-.006-.335q0-6.132,0-12.263V3.5",
    transform: "translate(-60.091 0)",
    fill: "#3d3d3d"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareNew);
export default __webpack_public_path__ + "static/media/share_new.305ecefbe09804850849cfd2f930e2a2.svg";
export { ForwardRef as ReactComponent };